import React from 'react';

import { Flex, Text, FlexProps } from '@chakra-ui/react';

export default function HistoryMenu({ mode, setMode }) {
  function Separator(props: FlexProps) {
    return (
      <Flex
        h={1}
        w="100%"
        bg="primary.default"
        {...props}
      />
    );
  }

  function Option({ label, isSelected = false, ...rest }) {
    return (
      <Flex
        pb={4}
        flexDir="column"
        {...rest}>
        <Text
          variant={isSelected ? 'smallBold' : 'smallSemiBold'}
          mx={2}
          mb={1}>
          {label}
        </Text>
        <Separator hidden={!isSelected} />
      </Flex>
    );
  }

  return (
    <Flex justifyContent="space-around">
      <Option
        cursor="pointer"
        onClick={() => setMode('current')}
        label="Rota Atual"
        isSelected={mode === 'current'}
      />
      <Option
        cursor="pointer"
        onClick={() => setMode('all')}
        label="Todas Edições"
        isSelected={mode === 'all'}
      />
    </Flex>
  );
}
